/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiDocument,
    InternalApiDocumentFromJSON,
    InternalApiDocumentToJSON,
    InternalDocumentsPage,
    InternalDocumentsPageFromJSON,
    InternalDocumentsPageToJSON,
} from '../models';

export interface DeleteSanctionAlertDocumentRequest {
    sanctionAlertId: number;
    documentId: number;
}

export interface DownloadSanctionAlertDocumentRequest {
    sanctionAlertId: number;
    documentId: number;
}

export interface FindAllDocumentsBySanctionAlertIdRequest {
    sanctionAlertId: number;
    page: number;
    size: number;
    query?: string;
}

export interface UploadSanctionAlertDocumentRequest {
    sanctionAlertId: number;
    file: Blob;
}

/**
 * 
 */
export class SanctionAlertDocumentInternalApi extends runtime.BaseAPI {

    /**
     * Delete document
     */
    async deleteSanctionAlertDocumentRaw(requestParameters: DeleteSanctionAlertDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiDocument>> {
        if (requestParameters.sanctionAlertId === null || requestParameters.sanctionAlertId === undefined) {
            throw new runtime.RequiredError('sanctionAlertId','Required parameter requestParameters.sanctionAlertId was null or undefined when calling deleteSanctionAlertDocument.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling deleteSanctionAlertDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/alerts/{sanctionAlertId}/documents/{documentId}`.replace(`{${"sanctionAlertId"}}`, encodeURIComponent(String(requestParameters.sanctionAlertId))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiDocumentFromJSON(jsonValue));
    }

    /**
     * Delete document
     */
    async deleteSanctionAlertDocument(requestParameters: DeleteSanctionAlertDocumentRequest, initOverrides?: RequestInit): Promise<InternalApiDocument> {
        const response = await this.deleteSanctionAlertDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Download document content
     */
    async downloadSanctionAlertDocumentRaw(requestParameters: DownloadSanctionAlertDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.sanctionAlertId === null || requestParameters.sanctionAlertId === undefined) {
            throw new runtime.RequiredError('sanctionAlertId','Required parameter requestParameters.sanctionAlertId was null or undefined when calling downloadSanctionAlertDocument.');
        }

        if (requestParameters.documentId === null || requestParameters.documentId === undefined) {
            throw new runtime.RequiredError('documentId','Required parameter requestParameters.documentId was null or undefined when calling downloadSanctionAlertDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/alerts/{sanctionAlertId}/documents/{documentId}`.replace(`{${"sanctionAlertId"}}`, encodeURIComponent(String(requestParameters.sanctionAlertId))).replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters.documentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Download document content
     */
    async downloadSanctionAlertDocument(requestParameters: DownloadSanctionAlertDocumentRequest, initOverrides?: RequestInit): Promise<Blob> {
        const response = await this.downloadSanctionAlertDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches all documents by sanction alert id
     */
    async findAllDocumentsBySanctionAlertIdRaw(requestParameters: FindAllDocumentsBySanctionAlertIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalDocumentsPage>> {
        if (requestParameters.sanctionAlertId === null || requestParameters.sanctionAlertId === undefined) {
            throw new runtime.RequiredError('sanctionAlertId','Required parameter requestParameters.sanctionAlertId was null or undefined when calling findAllDocumentsBySanctionAlertId.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling findAllDocumentsBySanctionAlertId.');
        }

        if (requestParameters.size === null || requestParameters.size === undefined) {
            throw new runtime.RequiredError('size','Required parameter requestParameters.size was null or undefined when calling findAllDocumentsBySanctionAlertId.');
        }

        const queryParameters: any = {};

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/sanctions/alerts/{sanctionAlertId}/documents`.replace(`{${"sanctionAlertId"}}`, encodeURIComponent(String(requestParameters.sanctionAlertId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalDocumentsPageFromJSON(jsonValue));
    }

    /**
     * Fetches all documents by sanction alert id
     */
    async findAllDocumentsBySanctionAlertId(requestParameters: FindAllDocumentsBySanctionAlertIdRequest, initOverrides?: RequestInit): Promise<InternalDocumentsPage> {
        const response = await this.findAllDocumentsBySanctionAlertIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Uploads new document
     */
    async uploadSanctionAlertDocumentRaw(requestParameters: UploadSanctionAlertDocumentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiDocument>> {
        if (requestParameters.sanctionAlertId === null || requestParameters.sanctionAlertId === undefined) {
            throw new runtime.RequiredError('sanctionAlertId','Required parameter requestParameters.sanctionAlertId was null or undefined when calling uploadSanctionAlertDocument.');
        }

        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling uploadSanctionAlertDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        const response = await this.request({
            path: `/v1/sanctions/alerts/{sanctionAlertId}/documents`.replace(`{${"sanctionAlertId"}}`, encodeURIComponent(String(requestParameters.sanctionAlertId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiDocumentFromJSON(jsonValue));
    }

    /**
     * Uploads new document
     */
    async uploadSanctionAlertDocument(requestParameters: UploadSanctionAlertDocumentRequest, initOverrides?: RequestInit): Promise<InternalApiDocument> {
        const response = await this.uploadSanctionAlertDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
